import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-steps-progress-bar',
  templateUrl: './steps-progress-bar.component.html',
  styleUrls: ['./steps-progress-bar.component.scss']
})
export class StepsProgressBarComponent implements OnInit, OnChanges {
  @Input() stepsMeta: number = 0;
  @Input() stepsReal: number = 0;
  @Input() colorStep?: string;
  @Input() colorStepAfter?: string = 'rgb(239, 68, 68)';
  @Input() colorStepBefore?: string = 'rgb(24, 144, 255)';
  @Input() colorStepGrey: string = '#dbdbdb';
  @Input() stepWidth?: number = 20;

  stepsArray: { status: string, width?: string, fractionalPart: number }[] = [];
  internalStepsMeta: number;

  constructor() { }

  ngOnInit(): void {
    this.initValues();
    this.generateSteps();
  }

  initValues() {
    this.stepsReal = this.stepsReal ? this.stepsReal : 0;
    this.stepsMeta = this.stepsMeta ? this.stepsMeta : 0;
    this.internalStepsMeta = Math.ceil(this.stepsMeta);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['stepsReal'] || changes['stepsMeta']) {
      this.initValues();
      this.generateSteps();
    }
  }

  generateSteps() {
    for (let i = 0; i < Math.max(this.stepsReal, this.internalStepsMeta); i++) {
      this.stepsArray[i] = { status: "grey", width: `${this.stepWidth}px`, fractionalPart: 0 };
    }
    for (let i = 0; i < this.stepsReal; i++) {
      this.stepsArray[i].status = "before";
    }
    for (let i = this.internalStepsMeta; i < Math.max(this.stepsReal, this.internalStepsMeta); i++) {
      this.stepsArray[i].status = "after";
    }
    if (this.stepsArray.length > 0) { // Add check to avoid error if stepsArray is empty
        this.stepsArray[this.stepsArray.length - 1].fractionalPart = this.stepsReal - Math.trunc(this.stepsReal);
    }
  }


  calculateClipPath(fractionalPart: number): string {
    if (fractionalPart >= 1 || fractionalPart <= 0) {
      return null; // No necesitamos clipPath si es 1 o 0
    }
    const percentage = fractionalPart * 100;
    return `inset(0 ${100 - percentage}% 0 0)`; // Recorta la parte derecha según fractionalPart
  }
}